import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetXola as ExternalWidgetXolaType } from "../../types/ExternalWidget";

export type ExternalWidgetXolaProps = Omit<ExternalWidgetXolaType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetXola({ sellerId, experienceId, ButtonComponent }: ExternalWidgetXolaProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    return (
        <Button className="xola-checkout" data-seller={sellerId} data-experience={experienceId}>
            {t("bokun.availabilityButton.label")}
        </Button>
    );
}
